import { render, staticRenderFns } from "./indextree.vue?vue&type=template&id=8bf66564&scoped=true&"
import script from "./indextree.vue?vue&type=script&lang=js&"
export * from "./indextree.vue?vue&type=script&lang=js&"
import style0 from "./indextree.vue?vue&type=style&index=0&id=8bf66564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf66564",
  null
  
)

export default component.exports